import { FC } from 'react';

const LoadingRows: FC = () => (
    <div className="flex flex-col gap-2 w-full">
        {Array.from({ length: 5 }, (_, index) => (
            <div
                key={index}
                className="flex-1 rounded-lg h-10 p-2 pl-4 flex flex-row justify-between items-center bg-sf-gray-0">
                <div className="flex flex-row gap-1">
                    <div className="h-4 w-32 bg-sf-gray-200 rounded animate-pulse" />
                    <div className="h-6 w-6" />
                </div>
                <div className="h-4 w-12 bg-sf-gray-200 rounded animate-pulse" />
            </div>
        ))}
    </div>
);

export default LoadingRows;
